<template>
    <div>
        <el-breadcrumb separator="/">
            <el-breadcrumb-item>
                <span class="page-title">币安合约</span>
            </el-breadcrumb-item>
            <el-breadcrumb-item>用户信息查询</el-breadcrumb-item>
        </el-breadcrumb>

        <el-form style="float:left;width: 100%;margin-top: 20px" :model="queryParams" :rules="queryParamsRules"
                 ref="paramsForm">
            <el-form-item style="display:inline-block;margin-right: 10px" prop="userId">
                <el-input v-model="queryParams.userId" placeholder="用户ID" style="width: 300px"></el-input>
            </el-form-item>
            <el-select v-model="queryParams.type">
                <el-option value="USDT" label="USDT合约"></el-option>
                <el-option value="COIN" label="币本位合约"></el-option>
            </el-select>
            <el-button type="primary" @click="getUserBalance">搜 索</el-button>
        </el-form>

        <!--USDT-->
        <div v-if="queryParams.type=='USDT'">
            <h2>详情</h2>
            <el-form inline>
                <el-form-item label="可用余额" style="width: 350px">{{usdtData.availableBalance}}</el-form-item>
                <el-form-item label="是否可以入金" style="width: 350px">{{usdtData.canDeposit}}</el-form-item>
                <el-form-item label="是否可以交易" style="width: 350px">{{usdtData.canTrade}}</el-form-item>
                <el-form-item label="是否可以出金" style="width: 350px">{{usdtData.canWithdraw}}</el-form-item>
                <el-form-item label="手续费等级:" style="width: 350px">{{usdtData.feeTier}}</el-form-item>
                <el-form-item label="最大可转出余额" style="width: 350px">{{usdtData.maxWithdrawAmount}}</el-form-item>
                <el-form-item label="全仓持仓未实现盈亏总额" style="width: 350px">{{usdtData.totalCrossUnPnl}}</el-form-item>
                <el-form-item label="全仓账户余额" style="width: 350px">{{usdtData.totalCrossWalletBalance}}</el-form-item>
                <el-form-item label="当前所需起始保证金总额" style="width: 350px">{{usdtData.totalInitialMargin}}</el-form-item>
                <el-form-item label="维持保证金总额" style="width: 350px">{{usdtData.totalMaintMargin}}</el-form-item>
                <el-form-item label="保证金总余额" style="width: 350px">{{usdtData.totalMarginBalance}}</el-form-item>
                <el-form-item label="当前挂单所需起始保证金" style="width: 350px">{{usdtData.totalOpenOrderInitialMargin}}
                </el-form-item>
                <el-form-item label="持仓所需起始保证金" style="width: 350px">{{usdtData.totalPositionInitialMargin}}
                </el-form-item>
                <el-form-item label="持仓未实现盈亏总额" style="width: 350px">{{usdtData.totalUnrealizedProfit}}</el-form-item>
                <el-form-item label="账户总余额" style="width: 350px">{{usdtData.totalWalletBalance}}</el-form-item>
            </el-form>

            <h2>资产</h2>
            <el-table border :header-cell-style="{background:'#FFF5F4',color:'#EC6D56'}" style="margin-top: 20px"
                      :data="usdtData.assets" :row-key="() => Math.random()">
                <el-table-column prop="asset" label="资产" show-overflow-tooltip></el-table-column>
                <el-table-column prop="availableBalance" label="可用余额" show-overflow-tooltip></el-table-column>
                <el-table-column prop="crossUnPnl" label="全仓持仓未实现盈亏" show-overflow-tooltip></el-table-column>
                <el-table-column prop="crossWalletBalance" label="全仓账户余额" show-overflow-tooltip></el-table-column>
                <el-table-column prop="initialMargin" label="当前所需起始保证金" show-overflow-tooltip></el-table-column>
                <el-table-column prop="maintMargin" label="维持保证金" show-overflow-tooltip></el-table-column>
                <el-table-column prop="marginBalance" label="保证金余额" show-overflow-tooltip></el-table-column>
                <el-table-column prop="maxWithdrawAmount" label="最大可转出余额" show-overflow-tooltip></el-table-column>
                <el-table-column prop="openOrderInitialMargin" label="当前挂单所需起始保证金"
                                 show-overflow-tooltip></el-table-column>
                <el-table-column prop="positionInitialMargin" label="持仓所需起始保证金" show-overflow-tooltip></el-table-column>
                <el-table-column prop="unrealizedProfit" label="未实现盈亏" show-overflow-tooltip></el-table-column>
                <el-table-column prop="walletBalance" label="余额" show-overflow-tooltip></el-table-column>
            </el-table>

            <h2>持仓</h2>
            <el-table border :header-cell-style="{background:'#FFF5F4',color:'#EC6D56'}" style="margin-top: 20px"
                      :data="usdtData.positions | filterData" :row-key="() => Math.random()">
                <el-table-column prop="symbol" label="交易对" show-overflow-tooltip></el-table-column>
                <el-table-column prop="positionSide" label="持仓方向" show-overflow-tooltip></el-table-column>
                <el-table-column prop="entryPrice" label="持仓成本价" show-overflow-tooltip></el-table-column>
                <el-table-column prop="initialMargin" label="当前所需起始保证金" show-overflow-tooltip></el-table-column>
                <el-table-column prop="isolated" label="是否是逐仓模式" show-overflow-tooltip></el-table-column>
                <el-table-column prop="leverage" label="杠杆倍率" show-overflow-tooltip></el-table-column>
                <el-table-column prop="maintMargin" label="维持保证金" show-overflow-tooltip></el-table-column>
                <el-table-column prop="maxNotional" label="当前杠杆下用户可用的最大名义价值" show-overflow-tooltip></el-table-column>
                <el-table-column prop="openOrderInitialMargin" label="当前挂单所需起始保证金"
                                 show-overflow-tooltip></el-table-column>
                <el-table-column prop="positionAmt" label="持仓数量" show-overflow-tooltip></el-table-column>
                <el-table-column prop="positionInitialMargin" label="持仓所需起始保证金" show-overflow-tooltip></el-table-column>
                <el-table-column prop="unrealizedProfit" label="持仓未实现盈亏" show-overflow-tooltip></el-table-column>
            </el-table>
        </div>

        <!--COIN-->
        <div v-if="queryParams.type=='COIN'">
            <h2>详情</h2>
            <el-form inline>
                <el-form-item label="是否可以入金" style="width: 350px">{{coinData.canDeposit}}</el-form-item>
                <el-form-item label="是否可以入金" style="width: 350px">{{coinData.canTrade}}</el-form-item>
                <el-form-item label="是否可以出金" style="width: 350px">{{coinData.canWithdraw}}</el-form-item>
                <el-form-item label="手续费等级" style="width: 350px">{{coinData.feeTier}}</el-form-item>
            </el-form>

            <h2>资产</h2>
            <el-table border :header-cell-style="{background:'#FFF5F4',color:'#EC6D56'}" style="margin-top: 20px"
                      :data="coinData.assets" :row-key="() => Math.random()">
                <el-table-column prop="asset" label="资产" show-overflow-tooltip></el-table-column>
                <el-table-column prop="walletBalance" label="账户余额" show-overflow-tooltip></el-table-column>
                <el-table-column prop="unrealizedProfit" label="全部持仓未实现盈亏" show-overflow-tooltip></el-table-column>
                <el-table-column prop="marginBalance" label="保证金余额" show-overflow-tooltip></el-table-column>
                <el-table-column prop="maintMargin" label="维持保证金" show-overflow-tooltip></el-table-column>
                <el-table-column prop="initialMargin" label="当前所需起始保证金" show-overflow-tooltip></el-table-column>
                <el-table-column prop="positionInitialMargin" label="当前所需持仓起始保证金"
                                 show-overflow-tooltip></el-table-column>
                <el-table-column prop="openOrderInitialMargin" label="当前所需挂单起始保证金"
                                 show-overflow-tooltip></el-table-column>
                <el-table-column prop="maxWithdrawAmount" label="最大可提款金额" show-overflow-tooltip></el-table-column>
                <el-table-column prop="crossWalletBalance" label="可用于全仓的账户余额" show-overflow-tooltip></el-table-column>
                <el-table-column prop="crossUnPnl" label="所有全仓持仓的未实现盈亏" show-overflow-tooltip></el-table-column>
                <el-table-column prop="availableBalance" label="可用下单余额" show-overflow-tooltip></el-table-column>
            </el-table>

            <h2>持仓</h2>
            <el-table border :header-cell-style="{background:'#FFF5F4',color:'#EC6D56'}" style="margin-top: 20px"
                      :data="coinData.positions | filterCData" :row-key="() => Math.random()">
                <el-table-column prop="symbol" label="交易对" show-overflow-tooltip></el-table-column>
                <el-table-column prop="initialMargin" label="当前所需起始保证金" show-overflow-tooltip></el-table-column>
                <el-table-column prop="maintMargin" label="持仓维持保证金" show-overflow-tooltip></el-table-column>
                <el-table-column prop="unrealizedProfit" label="持仓未实现盈亏" show-overflow-tooltip></el-table-column>
                <el-table-column prop="positionInitialMargin" label="当前所需持仓起始保证金"
                                 show-overflow-tooltip></el-table-column>
                <el-table-column prop="openOrderInitialMargin" label="当前所需挂单起始保证金"
                                 show-overflow-tooltip></el-table-column>
                <el-table-column prop="leverage" label="杠杆倍率" show-overflow-tooltip></el-table-column>
                <el-table-column prop="isolated" label="是否是逐仓模式" show-overflow-tooltip></el-table-column>
                <el-table-column prop="positionSide" label="持仓方向" show-overflow-tooltip></el-table-column>
                <el-table-column prop="entryPrice" label="平均持仓成本" show-overflow-tooltip></el-table-column>
                <el-table-column prop="maxQty" label="当前杠杆下最大可开仓数" show-overflow-tooltip></el-table-column>
            </el-table>
        </div>

    </div>
</template>

<script>
    import '../store';
    import api from '../api';

    export default {
        name: 'UserBalance',
        components: {},
        data() {
            return {
                usdtData: {},
                coinData: {},
                queryParams: {
                    userId: "",
                    type: "USDT",
                },
                queryParamsRules: {
                    "userId": [{required: true, message: "用户ID不能为空"}]
                },
            }
        },
        filters: {
            filterData(val) {
                if (!val) {
                    return [];
                }
                return val.filter((x) => x.positionAmt != 0);
            },
            filterCData(val) {
                if (!val) {
                    return [];
                }
                return val.filter((x) => x.maintMargin != 0);
            }
        },
        methods: {
            getUserBalance() {
                this.$refs["paramsForm"].validate(valid => {
                    if (valid) {
                        if (this.queryParams.type == "USDT") {
                            api.getAccountForUSDT(this.queryParams).then(({data}) => {
                                this.usdtData = data;
                            });
                        } else {
                            api.getAccountForCoin(this.queryParams).then(({data}) => {
                                this.coinData = data;
                            });
                        }
                    }
                });
            }
        },
        created() {
        }
    };
</script>

<style lang="less" scoped>

</style>

